export enum Environments {
  local = "local",
  dev = "dev",
  prod = "prod",
}
